import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { roleGuard } from './core/guards/role.guard';

export const routes: Routes = [
  // AUTH - PÚBLICO
  {
    path: 'auth',
    children: [
      {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full',
      },
      {
        path: 'login',
        loadComponent: () =>
          import('./auth/public-login-component/public-login-component').then(
            (m) => m.PublicLoginComponent
          ),
      },
      {
        path: 'registro',
        loadComponent: () =>
          import(
            './auth/public-register-component/public-register-component'
          ).then((m) => m.PublicRegisterComponent),
      },
      {
        path: 'olvido-contraseña',
        loadComponent: () =>
          import(
            './auth/public-forgot-pass-component/public-forgot-pass-component'
          ).then((m) => m.PublicForgotPassComponent),
      },
    ],
  },

  // APP PRIVADA (SIN PREFIJO)
  {
    path: '',
    canActivate: [authGuard, roleGuard],
    loadComponent: () =>
      import('./layouts/public-app-layout/public-app-layout').then(
        (m) => m.PublicAppLayout
      ),
    children: [
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full',
      },
      {
        path: 'home',
        loadComponent: () =>
          import('./public-app/home-component/home-component').then(
            (m) => m.HomeComponent
          ),
      },
      {
        path: 'cita',
        loadComponent: () =>
          import('./public-app/datecomponent/datecomponent').then(
            (m) => m.DateComponent
          ),
      },
    ],
  },

  // Fallback
  { path: '**', redirectTo: 'auth/login' },
];
